import { render, staticRenderFns } from "./Coaches.vue?vue&type=template&id=6a71f9ae&scoped=true"
import script from "./Coaches.vue?vue&type=script&lang=js"
export * from "./Coaches.vue?vue&type=script&lang=js"
import style0 from "./Coaches.vue?vue&type=style&index=0&id=6a71f9ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a71f9ae",
  null
  
)

export default component.exports